<template>
  <v-ons-page class="l-content l-paiement">
    <custom-toolbar backLabel="Retour">{{ $t("Mes paiements") }}</custom-toolbar>

    <div class="container">
      <v-ons-list-item expandable>
        <div class="center">
          <v-ons-button modifier="large">
            <i class="fas fa-home"></i>
            {{ $t("Paiement du bien") }}
            <i class="fas fa-home absoluteIcon"></i>
          </v-ons-button>
        </div>

        <div class="expandable-content">
          <div v-if="project_payments" class="table-responsive">
            <table class="table table-striped">
              <thead>
                <tr>
                  <td></td>
                  <td class="text-right">{{ $t("Montant") }}</td>
                  <td class="text-right">{{ $t("Payé") }}</td>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(payment, label) in project_payments" :key="label">
                  <td>{{ $t(label) }}</td>
                  <td class="text-right">
                    <span v-if="payment.amount != null">{{ amount.format(payment.amount) }}€</span>
                  </td>
                  <td class="text-right">
                    <span v-if="payment.amount != null">
                      <i class="fas" :class="{'fa-check':payment.paid == 1, 'fa-times':payment.paid != 1}"></i>
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </v-ons-list-item>

      <v-ons-list-item expandable>
        <v-ons-button modifier="large">
          <i class="fas fa-boxes"></i>{{ $t("Paiement des fournitures") }}<i class="fas fa-boxes absoluteIcon"></i>
        </v-ons-button>

        <div class="expandable-content">
          <div class="table-responsive">
            <table class="table table-striped">
              <thead>
                <tr>
                  <td></td>
                  <td class="text-right">{{ $t("Acompte") }}</td>
                  <td class="text-right">{{ $t("Payé") }}</td>
                  <td class="text-right">{{ $t("Solde") }}</td>
                  <td class="text-right">{{ $t("Payé") }}</td>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(payment, index) in orders_payments" :key="index">
                  <td>{{ payment.title }}</td>
                  <td class="text-right">
                    <span v-if="parseFloat(payment.acompte) != parseFloat(0)">{{ amount.format(payment.acompte) }}€</span>
                  </td>
                  <td class="text-right">
                    <span v-if="parseFloat(payment.acompte) != parseFloat(0)">
                      <i class="fas" :class="{'fa-check':payment.acompte_paid == 1, 'fa-times':payment.acompte_paid == 0}"></i>
                    </span>
                  </td>
                  <td class="text-right"><span v-if="parseFloat(payment.solde) != parseFloat(0)">{{ amount.format(payment.solde) }}€</span></td>
                  <td class="text-right">
                    <span v-if="parseFloat(payment.solde) != parseFloat(0)">
                      <i class="fas" :class="{'fa-check':payment.solde_paid == 1, 'fa-times':payment.solde_paid == 0}"></i>
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </v-ons-list-item>
    </div>
  </v-ons-page>
</template>

<script>
import amount from '../tools/amount.js';

export default {
  data() {
    return {
      user: loggedIn,
      orders_payments: [],
      project_payments: [],
      amount: amount
    };
  },
  created() {
    axios
      .get('/users/orders-payments', {
        params: {
          'x-secundo-auth': this.user.token,
          'prospect_id': this.user.pro_id,
        }
      })
      .then(response => {
        this.orders_payments = response.data;
      });

    axios
      .get('/users/project-payments', {
        params: {
          'x-secundo-auth': this.user.token,
          'prospect_id': this.user.pro_id,
        }
      })
      .then(response => {
        this.project_payments = response.data;
      });

  }
};
</script>


// WEBPACK FOOTER //
// Payments.vue?161aff0d